<p-card>
  @if (success) {
    <div class="recovery-success text-center">
      <div class="recovery-success__icon" aria-hidden="true">
        <i class="pi pi-check-circle"></i>
      </div>
      <h3>Revisa tu correo</h3>
      <p class="text-secondary">
        Si el email <strong>{{ submittedEmail }}</strong> está registrado, recibirás un correo con instrucciones
        para restablecer tu contraseña.
      </p>
      <p class="small text-secondary">
        Si no lo recibes en unos minutos, revisa la carpeta de spam o contacta con atención al cliente.
      </p>

      @if (error) {
        <p-message styleClass="mb-3 w-100" severity="error">{{ error }}</p-message>
      }

      <p-button
        [label]="resendLabel"
        severity="secondary"
        class="w-100 mt-3"
        [style]="{ width: '100%' }"
        [disabled]="resendLoading || resendCooldown > 0"
        [loading]="resendLoading"
        (onClick)="resendEmail()"
      />

      <p-button
        label="Volver al inicio de sesión"
        routerLink="/login"
        class="w-100 mt-2"
        [style]="{ width: '100%' }"
      />
    </div>
  } @else {
    <h3>He olvidado mi contraseña</h3>
    <form (ngSubmit)="submit()">
      <h5 class="mb-2">Introduce el email asociado a tu cuenta.</h5>
      <p-floatlabel class="mb-2" variant="in">
        <p-iconfield>
          <p-inputicon class="pi pi-envelope" />
          <input pInputText id="email" class="w-100" [formControl]="emailCtrl" autocomplete="email" />
        </p-iconfield>
        <label for="email">Email</label>
      </p-floatlabel>
      <p class="small">Recibirás un correo electrónico con instrucciones para crear una nueva contraseña.</p>

      @if (error) {
        <p-message styleClass="mb-3" severity="error">{{ error }}</p-message>
      }

      <p-button
        type="submit"
        [label]="submitted ? 'Enviando...' : 'Enviar'"
        class="w-100"
        [style]="{ width: '100%' }"
        [disabled]="emailCtrl.invalid || submitted"
        [loading]="submitted"
      />

      <p-button
        severity="secondary"
        styleClass="mt-2"
        [text]="true"
        label="Volver"
        routerLink="/login"
        class="w-100"
        [style]="{ width: '100%' }"
      />

      <div class="mt-3 w-100 d-flex">
        <img class="img-fluid px-5 mx-auto" [src]="brandProfile.logoPath" [alt]="brandProfile.companyName" />
      </div>

      <p class="legal-links small text-center mt-3 mb-0">
        <a [href]="legalNoticeUrl" target="_blank" rel="noopener noreferrer">Aviso legal</a>
        <span class="mx-2">·</span>
        <a [href]="privacyPolicyUrl" target="_blank" rel="noopener noreferrer">Política de privacidad</a>
      </p>
    </form>
  }
</p-card>
